import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { kebabCase } from 'lodash';
import { Label } from 'reactstrap';
import SegmentedPickerButton from './segmentedPickerButton';
const SegmentedPicker = ({
  onChange,
  value: propsValue = null,
  allowNull: _allowNull = true,
  values: _values = [],
  names,
  label: _label = '\u00a0',
  hideLabel: _hideLabel = false,
  className: _className = '',
  isDisabled: _isDisabled = false
}) => {
  const handleClick = value => {
    let newValue;
    if (_allowNull) {
      // If the value is currently set, toggle it to null
      newValue = value === propsValue ? null : value;
    } else if (propsValue !== value) {
      newValue = value;
    }

    // Only update the value if it actually changed
    if (typeof newValue !== 'undefined') {
      onChange(newValue);
    }
  };
  const buttons = names.map((name, index) => {
    let value;
    if (_values && _values.length === names.length) {
      value = _values[index];
    } else {
      value = index;
    }
    const classes = classnames({
      active: propsValue === value,
      leftButton: index === 0,
      rightButton: index === names.length - 1,
      middleButton: index !== 0 && index !== names.length - 1,
      'form-control': true,
      [`t-sp-button t-sp-${kebabCase(name)}`]: true,
      'tqc-control': true
    });
    const width = 100 / names.length;
    return /*#__PURE__*/React.createElement(SegmentedPickerButton, {
      className: classes,
      key: name,
      isDisabled: _isDisabled,
      onClick: handleClick,
      value: value,
      width: width
    }, name);
  });
  const classNames = kebabCase(_className.length > 0 ? _className : `t-dtp-${_label}`);
  return /*#__PURE__*/React.createElement("div", {
    className: `form-group ${classNames}`
  }, _hideLabel ? null : /*#__PURE__*/React.createElement(Label, {
    className: "text-input-custom-label"
  }, _label), /*#__PURE__*/React.createElement("div", {
    className: `s-sp ${classNames}`
  }, buttons));
};
SegmentedPicker.propTypes = {
  className: PropTypes.string,
  allowNull: PropTypes.bool,
  hideLabel: PropTypes.bool,
  label: PropTypes.string,
  names: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
  values: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool])),
  isDisabled: PropTypes.bool
};
export default SegmentedPicker;